import { useWSQuery, WSQueryConfig } from "@ws-react-query";
import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { ListRequestQuery, WSServiceError } from "../../utils/serviceHelper";
import { getPlanEnrollments } from "../../services/api/planEnrollment/getPlanEnrollments";
import { IPlanEnrollmentListQueryFilter } from "../../services/api/planEnrollment/types";

type IPlanEnrollment = planEnrollmentApiSpec.PlanEnrollment;
type IPlanEnrollmentListQuerySort = NonNullable<
  planEnrollmentApiSpec.operations["listPlanEnrollments"]["parameters"]["query"]
>["sort"];

export const QUERY_BENEFITS_PLAN_ENROLLMENTS =
  "QUERY_BENEFITS_PLAN_ENROLLMENTS";

export const useQueryPlanEnrollments = (
  params: ListRequestQuery<
    IPlanEnrollmentListQueryFilter,
    IPlanEnrollmentListQuerySort
  >,
  config?: WSQueryConfig<IPlanEnrollment[], WSServiceError>
) =>
  useWSQuery(
    [QUERY_BENEFITS_PLAN_ENROLLMENTS, params],
    () => getPlanEnrollments(params),
    config
  );
